import { useState } from "react";
import { useDispatch } from "react-redux";
import cancelImage from "../assets/images/cancel.png";
import deleteTodo from "../redux/todos/thunk/deleteTodo";
import updateColor from "../redux/todos/thunk/updateColor";
import updateStatus from "../redux/todos/thunk/updateStatus";

export default function Todo({ todo }) {
    const dispatch = useDispatch();
    const [showModal, setShowModal] = useState(false);
    const { text, id, completed, color } = todo;

    const handleStatusChange = (todoId) => {
        dispatch(updateStatus(todoId, completed));
    };

    const handleColorChange = (todoId, color) => {
        dispatch(updateColor(todoId, color));
    };

    const handEditChange = (id) => {
        console.log("i am edit")
        setShowModal(true)

    }
    const handleUpdateChange = () => {

    }

    const handleDelete = (todoId) => {
        dispatch(deleteTodo(todoId));
    };

    return (
        <>
            {showModal && <>
                <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div className="relative w-auto my-6 mx-auto max-w-3xl">
                        <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            <div className="flex items-start justify-between p-5 border-b border-solid border-gray-300 rounded-t ">
                                <h3 className="text-3xl font=semibold">Task Info</h3>
                                <button
                                    className="bg-transparent border-0 text-black float-right"
                                    onClick={() => setShowModal(false)}
                                >
                                    <span className="text-black opacity-7 h-6 w-6 text-xl block bg-gray-400 py-0 rounded-full">
                                        x
                                    </span>
                                </button>
                            </div>
                            <div className="relative p-6 flex-auto">
                                <form className="bg-gray-200 shadow-md rounded px-8 pt-6 pb-8 w-full" onSubmit={() => handleUpdateChange()}>
                                    <label className="block text-black text-sm font-bold mb-1">
                                        Update Task
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-1 text-black" />

                                </form>
                            </div>
                            <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                <button
                                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    className="text-white bg-yellow-500 active:bg-yellow-700 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                                    type="button"
                                    onClick={() => setShowModal(false)}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            {!completed &&
                <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
                    <div
                        className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center items-center mr-2 ${completed &&
                            "border-green-500 focus-within:border-green-500"
                            }`}
                    >
                        <input
                            type="checkbox"
                            checked={completed}
                            onChange={() => handleStatusChange(id)}
                            className="opacity-0 absolute rounded-full"
                        />
                        {completed && (
                            <svg
                                className="fill-current w-3 h-3 text-green-500 pointer-events-none"
                                viewBox="0 0 20 20"
                            >
                                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
                            </svg>
                        )}
                    </div>

                    <div
                        className="select-none flex-1"
                    >
                        {text}
                    </div>

                    <div
                        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${color === "green" && "bg-green-500"
                            }`}
                        onClick={() => handleColorChange(id, "green")}
                    ></div>

                    <div
                        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${color === "yellow" && "bg-yellow-500"
                            }`}
                        onClick={() => handleColorChange(id, "yellow")}
                    ></div>

                    <div
                        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${color === "red" && "bg-red-500"
                            }`}
                        onClick={() => handleColorChange(id, "red")}
                    ></div>
                    <div
                        className={`flex-shrink-0 h-4 w-4 cursor-pointer "
              }`}
                        onClick={() => handEditChange(id)}
                    >
                        <i class="fas fa-edit"></i>

                    </div>

                    <img
                        src={cancelImage}
                        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
                        alt="Cancel"
                        onClick={() => handleDelete(id)}
                    />

                </div>
            }

        </>
    );
}
